import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import useProductName from "brand-customization/useProductName";
import { DocumentTitle, PageHeader } from "components/common";
import { Alert } from "components/bootstrap";
const StyledAlert = styled(Alert)`
  margin-top: 15px;
`;
const OpenSearchRequiredPage = () => {
  const { t } = useTranslation("enterprise_security_app");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("open_search_required.title") }, /* @__PURE__ */ React.createElement(PageHeader, { title: t("open_search_required.title") }, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "danger", className: "tm", title: t("open_search_required.alert_title") }, /* @__PURE__ */ React.createElement("p", null, t("open_search_required.description", { productName })))));
};
export default OpenSearchRequiredPage;
